import ChangePassword from '~/containers/ChangePassword';
import { Paper } from '@mui/material';
import { Box } from '@mui/system';

function ChangePasswordPage() {
  return (
    <Box ml={2} mr={2}>
      <Paper elevation={3} style={{ padding: '15px 0', borderRadius: 20, maxWidth: 450, margin: '100px auto' }}>
        <ChangePassword />
      </Paper>
    </Box>
  );
}

export default ChangePasswordPage;
